export default __webpack_public_path__ + "static/jeff-11b86717f7de9141cd3346a45ebbaca6.png";